import { ThumbnailMetrics } from 'Roblox';
import { batchRequestFactory, BatchItemProcessor } from 'core-utilities';
import {
  DefaultBatchSize,
  ThumbnailCooldown,
  ThumbnailRequesters,
  ThumbnailCache
} from '../constants/thumbnail2dConstant';

export const idSerializer = (id: number) => {
  return id?.toString() ?? '';
};

const thumbnailRequesterProperties = {
  getFailureCooldown: batchRequestFactory.createExponentialBackoffCooldown(
    ThumbnailCooldown.minCooldown,
    ThumbnailCooldown.maxCooldown
  ),
  maxRetryAttempts: ThumbnailCooldown.maxRetryAttempts,
  batchSize: DefaultBatchSize
};

const thumbnailRequesters: ThumbnailRequesters = {};
const thumbnailCache: ThumbnailCache = {};

const getThumbnailRequester = (
  thumbnailRequestProcessor: BatchItemProcessor,
  thumbnailRequesterKey: string
) => {
  if (thumbnailRequesterKey in thumbnailRequesters) {
    return thumbnailRequesters[thumbnailRequesterKey];
  }

  const processor = batchRequestFactory.createRequestProcessor(
    thumbnailRequestProcessor,
    idSerializer,
    thumbnailRequesterProperties
  );
  thumbnailRequesters[thumbnailRequesterKey] = processor;
  return processor;
};

const processThumbnailBatchRequest = (
  targetId: number,
  thumbnailRequestProcessor: BatchItemProcessor,
  thumbnailRequesterKey: string,
  thumbnailCacheKey: string,
  clearCachedValue: boolean
) => {
  if (clearCachedValue && thumbnailCacheKey) {
    delete thumbnailCache[thumbnailCacheKey];
  }

  if (!(thumbnailCacheKey in thumbnailCache)) {
    const batchRequester = getThumbnailRequester(thumbnailRequestProcessor, thumbnailRequesterKey);

    if (clearCachedValue) {
      batchRequester.invalidateItem(targetId);
    }
    const result = batchRequester.queueItem(targetId).catch((data: object) => {
      if (ThumbnailMetrics) {
        ThumbnailMetrics.logThumbnailTimeout();
      }
      // chain the rejection so that other listeners get triggered.
      return Promise.reject(data);
    });

    thumbnailCache[thumbnailCacheKey] = result;
  }

  return thumbnailCache[thumbnailCacheKey];
};

export default {
  processThumbnailBatchRequest
};
